import { useEffect, useState, useRef } from 'react';
import ChevronDown from '@/icons/ChevronDown';

type LocatorHoursProps = {
  isPayAtPump247: boolean | number;
  openingHours: Array<{
    hours: string;
    day: string;
  }>;
}

const LocatorHours: React.FC<LocatorHoursProps> = ({
  isPayAtPump247,
  openingHours
}) => {
  const [open, setOpen] = useState(false);

  const buttonText = isPayAtPump247
    ? '24/7 pay at pump'
    : openingHours.every((h) => h.hours === 'Open 24 hours')
    ? 'Open 24 hours'
    : 'Opening hours';

  const hoursEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = hoursEl.current.closest<HTMLElement>('.locator-results');
    const initialTop = container.getAttribute('initial-top');

    if (open && initialTop) {
      container.classList.add('hour-list-open');
      container.style.top = '0';
    } else {
      container.style.top = initialTop;
      container.classList.remove('hour-list-open');
    }
  }, [open])

  return (
    <div className="locator-hours" ref={hoursEl}>
      <button
        className={[
          'locator-hours__button',
          'h6',
          open ? 'locator-hours__button--open' : null,
        ].join(' ')}
        onClick={() => setOpen(!open)}
      >
        {buttonText}
        <ChevronDown fill="#1E196A" width={11} />
      </button>
      {open && (
        <table className="locator-hours__table">
          <thead className="sr-only">
            <tr>
              <th>Day</th>
              <th>Opening hours</th>
            </tr>
          </thead>
          <tbody>
            {openingHours.length > 0 &&
              openingHours.map((openingHour, i) => {
                const { day, hours } = openingHour;

                return (
                  <tr key={i}>
                    <td
                      className={[
                        'locator-hours__table-cell',
                        'locator-hours__table-cell--day',
                      ].join(' ')}
                    >
                      {day}
                    </td>
                    <td
                      className={[
                        'locator-hours__table-cell',
                        'locator-hours__table-cell--hours',
                      ].join(' ')}
                    >
                      {hours}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LocatorHours;
